/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { presignedUrlModelSchema } from "./presignedUrlModelSchema.ts";
import { z } from "zod";

export const presignedUrlTrackModelSchema = z.object({
    "file": z.lazy(() => presignedUrlModelSchema),
"trackId": z.string().uuid()
    })